// Vendors
import { useLayoutEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useAppInformationContextConsumerHook } from 'contexts/app-information.context';
// Event handlers
import InternationalizationHandlers from '../handlers/internationalization.handlers';
// Types
import { InternationalizationReturnHookType } from './types/internationalization-return.hook.type';
// Utilities
import {
  getLocaleFromQueryParam,
  getTranslationsFromStorage,
  getUserLanguage,
} from './utils/internationalization.hook.utils';

const useInternationalizationHook = (): InternationalizationReturnHookType => {
  const { showBoundary: setError } = useErrorBoundary();

  const locale = getUserLanguage({ languagePreference: getLocaleFromQueryParam() });

  const [fetching, setFetching] = useState<boolean>(false);
  const [translations, setTranslations] = useState(getTranslationsFromStorage());

  const { setInformationFlags } = useAppInformationContextConsumerHook();

  const { handleFetchTranslations } = InternationalizationHandlers({
    locale,
    setError,
    setTranslations,
    setFetching,
    setInformationFlags,
  });

  useLayoutEffect(() => {
    handleFetchTranslations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  return {
    fetching,
    locale,
    translations,
  };
};

export { useInternationalizationHook };
